import apiWrapper from './helpers';

export default class DocumentLabel extends apiWrapper('/document_labels') {

}
